import React from 'react';
import ReactMarkdown from 'react-markdown';
import { getAboutPage, } from '../utils/api/pageApi';
import './AboutPage.less';
var fallbackTeamImage = '/static/img/people/no-image.jpg';
var MarkdownLink = function (_a) {
    var href = _a.href, children = _a.children;
    var isExternal = href && /^https?:\/\//.test(href);
    return React.createElement("a", { href: href, className: href === '#' ? 'contact-us' : undefined, target: isExternal ? '_blank' : undefined, rel: isExternal ? 'noreferrer' : undefined }, children);
};
var MarkdownBlock = function (_a) {
    var source = _a.source;
    return (React.createElement(ReactMarkdown, { source: source, renderers: {
            link: MarkdownLink,
        } }));
};
var AboutSection = function (_a) {
    var section = _a.section;
    return (React.createElement("section", { className: "object stats about-page__section", id: section.id },
        React.createElement("h2", null, section.title),
        React.createElement(MarkdownBlock, { source: section.bodyMarkdown })));
};
var TeamMember = function (_a) {
    var member = _a.member;
    var useFallbackImage = function (event) {
        var image = event.currentTarget;
        image.onerror = null;
        image.src = fallbackTeamImage;
    };
    return React.createElement("li", null,
        React.createElement("picture", null,
            React.createElement("img", { src: member.imageUrl, alt: member.name + ", " + member.role + " for iBok", onError: useFallbackImage })),
        React.createElement("strong", null, member.name),
        React.createElement("em", null, member.role));
};
var TeamSection = function (_a) {
    var members = _a.members;
    if (members.length === 0) {
        return null;
    }
    return React.createElement("section", { className: "about-page__team" },
        React.createElement("h2", null, "De frivillige bak iBok"),
        React.createElement("ul", { className: "grid people" }, members.map(function (member) { return (React.createElement(TeamMember, { key: member.id, member: member })); })));
};
var AboutContent = function (_a) {
    var page = _a.page;
    return (React.createElement("div", { className: "main-content about-page" },
        React.createElement("h1", null, page.title),
        React.createElement("div", { className: "about-page__introduction" },
            React.createElement(MarkdownBlock, { source: page.introductionMarkdown })),
        React.createElement("div", { className: "about-page__sections" }, page.sections.map(function (section) { return (React.createElement(AboutSection, { key: section.id, section: section })); })),
        React.createElement(TeamSection, { members: page.teamMembers })));
};
var AboutPage = function () {
    var _a = React.useState(null), page = _a[0], setPage = _a[1];
    var _b = React.useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = React.useState(null), error = _c[0], setError = _c[1];
    React.useEffect(function () {
        var isMounted = true;
        setIsLoading(true);
        setError(null);
        getAboutPage()
            .then(function (nextPage) {
            if (isMounted) {
                setPage(nextPage);
            }
        })
            .catch(function () {
            if (isMounted) {
                setError('Kunne ikke hente om-siden akkurat nå.');
            }
        })
            .finally(function () {
            if (isMounted) {
                setIsLoading(false);
            }
        });
        return function () {
            isMounted = false;
        };
    }, []);
    if (isLoading) {
        return React.createElement("div", { className: "main-content about-page" },
            React.createElement("p", null, "Laster innhold..."));
    }
    if (error || !page) {
        return React.createElement("div", { className: "main-content about-page" },
            React.createElement("h1", null, "Om iBok"),
            React.createElement("p", null, error || 'Kunne ikke hente om-siden akkurat nå.'));
    }
    return React.createElement(AboutContent, { page: page });
};
export default AboutPage;
